import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class PersonsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getPartyRoles(partyId: number) {
        return this.get(EndPoints.persons_getPartyRoles, undefined, partyId, undefined);
    }

    searchRecruiters(searchString: string): Observable<any> {
        return this.post<any>(EndPoints.persons_getRecruiters, false, '', 
            {
                searchString: searchString
            }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
             return throwError(() => new Error(err));
         })
        );
    }
}
